import { Link } from '@tanstack/react-router';
import { env } from '../../lib/env.ts';

const TABS = [
  { to: '/settings/workspace', label: 'General' },
  { to: '/settings/members', label: 'Members' },
  { to: '/settings/fields', label: 'Fields' },
  { to: '/settings/tags', label: 'Tags' },
  { to: '/settings/numbers', label: 'Numbers' },
  { to: '/settings/compliance', label: 'Compliance' },
  { to: '/settings/sending-hours', label: 'Sending hours' },
  { to: '/settings/suppression', label: 'Suppression' },
  { to: '/settings/lead-sources', label: 'Lead sources' },
  { to: '/settings/campaigns', label: 'Campaigns' },
] as const;

/**
 * Sub-navigation of the admin settings pages (kept out of the main nav so phones keep their tabs). The
 * pills wrap onto another line instead of scrolling sideways, so no section is ever hidden off-screen.
 * Local builds add the dev simulator.
 */
export function SettingsTabs() {
  const tabs =
    env().VITE_APP_ENV === 'local'
      ? [...TABS, { to: '/dev/simulator' as const, label: 'Simulator' }]
      : TABS;
  return (
    <nav aria-label="Settings sections" className="-mt-1 flex flex-wrap gap-1">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className="callout inline-flex min-h-11 items-center whitespace-nowrap rounded-pill px-4 font-semibold text-ink-muted hover:bg-surface hover:text-ink focus-visible:outline-2 focus-visible:outline-focus-ring data-[status=active]:bg-brand-tint data-[status=active]:text-brand-on-tint"
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
